import { Link } from 'react-router-dom';
import {
	MapPin,
	Mail,
	Smartphone,
	Phone,
	Facebook,
	Instagram,
	Linkedin,
	Youtube,
	ChevronRight,
} from 'lucide-react';
import './Footer.css';

const quickLinksLeft = [
	{ label: 'Academy', to: '/qui-sommes-nous' },
	{ label: 'Formations', to: '/formations' },
];

const quickLinksRight = [
	//{ label: 'Parcours', to: '/formations' },
	//{ label: 'Actualité', to: '/single-event' },
	{ label: 'Contact', to: '/contact' },
];

const socials = [
	{
		icon: Facebook,
		href: 'https://www.facebook.com/ClevoryAcademy',
		label: 'Facebook',
	},
	{
		icon: Instagram,
		href: 'https://www.instagram.com/clevory_academy/',
		label: 'Instagram',
	},
	{
		icon: Linkedin,
		href: 'https://www.linkedin.com/company/clevoryacademy/posts/?feedView=all',
		label: 'LinkedIn',
	},
	{
		icon: Youtube,
		href: 'https://www.youtube.com/@ClevoryAcademy',
		label: 'YouTube',
	},
];

export default function Footer() {
	return (
		<footer className='site-footer'>
			<div className='site-footer__glow site-footer__glow--one' />
			<div className='site-footer__glow site-footer__glow--two' />

			<div className='site-footer__container'>
				<div className='site-footer__grid'>
					<div className='site-footer__column'>
						<h3 className='site-footer__title'>CONTACTEZ-NOUS</h3>
						<span className='site-footer__title-line' />

						<div className='site-footer__contact-list'>
							<a
								className='site-footer__contact-item'
								href='https://maps.google.com/?q=8 Rue des Minéraux, Charguia 1, Tunis'
								target='_blank'
								rel='noreferrer'>
								<span className='site-footer__icon-wrap'>
									<MapPin size={22} />
								</span>
								<span>8 Rue des Minéraux, Charguia 1, 2035, Tunis.</span>
							</a>

							<a
								className='site-footer__contact-item'
								href='mailto:admission@clevoryacademy.com'>
								<span className='site-footer__icon-wrap'>
									<Mail size={22} />
								</span>
								<span>admission@clevoryacademy.com</span>
							</a>

							<a
								className='site-footer__contact-item'
								href='tel:+21629376774
'>
								<span className='site-footer__icon-wrap'>
									<Smartphone size={22} />
								</span>
								<span>(+216) 29 376 774</span>
							</a>

							<a className='site-footer__contact-item' href='tel:+21631404377'>
								<span className='site-footer__icon-wrap'>
									<Phone size={22} />
								</span>
								<span>(+216) 31 404 377</span>
							</a>
						</div>
					</div>

					<div className='site-footer__column'>
						<h3 className='site-footer__title'>LIENS RAPIDES</h3>
						<span className='site-footer__title-line' />

						<div className='site-footer__links-grid'>
							<div className='site-footer__links-col'>
								{quickLinksLeft.map((item) => (
									<Link
										key={item.label}
										to={item.to}
										className='site-footer__link'>
										<ChevronRight size={16} />
										<span>{item.label}</span>
									</Link>
								))}
							</div>

							<div className='site-footer__links-col'>
								{quickLinksRight.map((item) =>
									item.to.startsWith('#') ? (
										<a
											key={item.label}
											href={item.to}
											className='site-footer__link'>
											<ChevronRight size={16} />
											<span>{item.label}</span>
										</a>
									) : (
										<Link
											key={item.label}
											to={item.to}
											className='site-footer__link'>
											<ChevronRight size={16} />
											<span>{item.label}</span>
										</Link>
									),
								)}
							</div>
						</div>
					</div>

					<div className='site-footer__column'>
						<h3 className='site-footer__title'>REJOIGNEZ NOUS</h3>
						<span className='site-footer__title-line' />

						<p className='site-footer__social-text'>
							Suivez-nous sur nos réseaux pour découvrir nos nouveautés,
							formations et actualités.
						</p>

						<div className='site-footer__socials'>
							{socials.map(({ icon: Icon, href, label }) => (
								<a
									key={label}
									href={href}
									target='_blank'
									rel='noreferrer'
									aria-label={label}
									className='site-footer__social-link'>
									<span className='site-footer__social-ring' />
									<Icon size={20} />
								</a>
							))}
						</div>
					</div>
				</div>
			</div>

			<div className='site-footer__bottom'>
				<div className='site-footer__container site-footer__bottom-inner'>
					<p className='site-footer__copyright'> &copy;2026 COPYRIGHT </p>
					<p className='site-footer__credit'>
						RÉALISER PAR <span>ZEENOVI</span>
					</p>
				</div>
			</div>
		</footer>
	);
}
